<script>
	import {External, M} from "../../../external";
	import {onMount} from "svelte";
  import { calcPercent } from '../../../Common/tools';

	export let circleDetails = {}, pageStats = {}, salesStats = {};

	let completedPercent = 0;
	let purchaseRatePercent = 0;
	let members = 0;
	let customers = 0;
	let arpu = 0;

	onMount(() => {
		members = circleDetails?.circle?.members || 0;
		customers = salesStats?.customers || 0;
		let completed = pageStats?.completed || 0;

		if (members > 0) {
			completedPercent = calcPercent(completed, members);
			purchaseRatePercent = calcPercent(customers, members);
		}

		arpu = External.Tools.currencyToStrWithSymbol(customers == 0 ? 0 : (salesStats?.sales / customers));
	})
</script>

<div class="flex col20 f-left store-section-analytics-warapper double-row-analytics flex-col-mobile" style="margin-top: 0px; background: #f5f6fa;">
	<div class="analytics-box analytics-box-small col5">
		<h3 class="flex align-center">{M.COMPLETED_CONTENT}
			<span class="chart-color ml-10" style="background: rgb(61, 166, 255) none repeat scroll 0% 0%;"></span>
		</h3>
		<h2 class="col20 f-left f-28 gray-text"><b>{pageStats?.completed || 0}</b></h2>
	</div>
	<div class="analytics-box analytics-box-small">
		<h3 class="flex align-center">{M.TOTAL_COMPLETION_RATE}
			<span class="material-icons-outlined ml-5 stats-info" style="font-size: 20px;"> info
				<span class="none-soft hidden-info">
					<h4>{M.COMPLETION_RATE}</h4>
					<span>{M.COMPLETED_CONTENT_DESC}</span>
				</span>
			</span>
		</h3>
		<h2 class="col20 f-left f-28 gray-text"><b>{completedPercent}</b><span>({members} {members === 1 ? M.MEMBER : M.MEMBERS})</span></h2>
	</div>
	<div class="analytics-box analytics-box-small">
		<h3 class="flex align-center">
			{M.REVENUE}
			<span class="chart-color ml-10" style="background: rgb(249, 127, 127) none repeat scroll 0% 0%;"></span>
		</h3>
		<h2 class="col20 f-left f-28 gray-text">
			<b>{External.Tools.currencyToStrWithSymbol(salesStats?.sales)}</b>
			<span>({salesStats?.orders || 0} {M.ORDERS})</span>
		</h2>
	</div>
	<div class="analytics-box analytics-box-small col5">
		<h3 class="flex align-center">{M.TOTAL_PURCHASE_RATE}
			<span class="material-icons-outlined ml-5 stats-info" style="font-size: 20px;">info
				<span class="none-soft hidden-info">
					<h4>{M.PURCHASE_RATE}</h4>
					<span>{M.PURCHASE_RATE_DESC}</span>
				</span>
			</span>
		</h3>
		<h2 class="col20 f-left f-28 gray-text">
			<b>{purchaseRatePercent}</b>
			<span>({customers} {M.PAYING_MEMBERS})</span>
		</h2>

	</div>
	<div class="analytics-box analytics-box-small">
		<h3 class="flex align-center">
			{M.ARPU}
			<span class="material-icons-outlined ml-5 stats-info" style="font-size: 20px;">info
				<span class="none-soft hidden-info">
					<h4>{M.AVERAGE_REVENUE_PER_USER}</h4>
					<span>{M.AVERAGE_REVENUE_PER_USER_DESC}</span>
				</span>
			</span>
		</h3>
		<h2 class="col20 f-left f-28 gray-text"><b>{arpu}</b></h2>
	</div>
</div>
